var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgAlertSuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 12",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.43431 11.7314L0.234305 6.53138C-0.0781016 6.21898 -0.0781016 5.71245 0.234305 5.40001L1.36565 4.26863C1.67805 3.9562 2.18462 3.9562 2.49702 4.26863L5.99999 7.77157L13.503 0.268637C13.8154 -0.0437693 14.3219 -0.0437693 14.6343 0.268637L15.7657 1.40001C16.0781 1.71242 16.0781 2.21895 15.7657 2.53139L6.56568 11.7314C6.25324 12.0438 5.74671 12.0438 5.43431 11.7314Z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertSuccess);
export default __webpack_public_path__ + "static/media/AlertSuccess.e9ef1e12bf6ed816a2a150a00445a236.svg";
export { ForwardRef as ReactComponent };